import { createContext } from "react";

export const UiContext = createContext()